module.exports = __webpack_public_path__ + "img/project status 2.0e4e6d19.jpg";